export const keyCodes = Object.freeze({
    TAB: 'Tab',
    RETURN: 'Enter',
    ESC: 'Escape',
    LEFT: 'ArrowLeft',
    UP: 'ArrowUp',
    RIGHT: 'ArrowRight',
    DOWN: 'ArrowDown',
});
